import React, { lazy, useEffect, useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import {
//   kycdocstatus,
//   savequeries,
//   updategotokyc,
// } from "../../../store/User/KycSlice";
// import {
//   // bookcargocredit,
//   getcreditlimit,
// } from "../../../store/User/CreditLimitSlice";
import{updateStoredSearch,bookingdata} from '../../../store/Newsearchform/Newsearchform'

// import {
//   updatebookinghistorytabvalue,
//   updatenotificationdata,
// } from "../../../store/Common/CommonSlice";
// import {
 
//   getsinglebookingdata,
// } from "../../../store/BookingHistory/BookingHistorySlice";
import CashFreePaymentModal from "./CashFreePaymentModal";
import ManualPayment from "./ManualPayment";
// NOTE: payment_failure (QueriesSlice' `paymentfailed`) is deliberately NOT
// imported — that endpoint is no longer called from anywhere in the app.
import AlertDialogBox from "../AlertDialogBox";
// import { set } from "react-hook-form";
const PaymentDetailsModal = lazy(() => import("./PaymentDetailsModal"));
const CargoPayment = lazy(() => import("./CargoPayment"));

const BookCargo = ({ nodeData,queryidall, prevbookingamt,selecteddata,setOpenbooking ,setSelecteddata,handleClose ,open,setOpen1,props}) => {
  // console.log(props,"propsbooking");
   const state = useSelector(updateStoredSearch);
  // const queryiddata=useSelector(updatequeryid);
  
    // console.log(state, 'state')
   
    const { rqueryid } = state?.payload?.newsearchform
    // console.log(newsearchformdata, 'bbokcargo',rqueryid)
  // const [open, setOpen] = useState(false);
  // console.log(nodeData, "nodeData345",queryidall);
  const [, setSpinner] = useState(false);
  // const [api, contextHolder] = notification.useNotification();
  const [openModal, setOpenModal] = useState(false);
  const [, setPaymentDetailsModal] = useState(false);
  const [useCreditAmount, setUseCreditAmount] = useState(true);
  const [creditLimitData] = useState();
  const [queryId, setQueryId] = useState( 
rqueryid
  );
  // const [selectedItem, setSelectedItem] = useState();
  const [remainingBalance, setRemainingBalance] = useState();
  // const[newnodedata,setNewnodedata] = useState(nodeData);
  // const [newprops,setNewprops] = useState(props);
  const [orderId, setOrderId] = useState("");
  // const [creditPayedAmount, setCreditPayedAmount] = useState();
  // const [paymentId, setPaymentId] = useState();
  const [paymentSessionId, setPaymentSessionId] = useState("");
  const [queryDatas, setQueryDatas] = useState({});
  const [, setResponseMsg] = useState({});
  const [bookingType, setBookingType] = useState();
//  const [singlebookingdata,setsinglebookingdata]=useState();
//  console.log("bookcargo",nodeData,selecteddata,props,queryId);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // console.log("openbc",open)


  const handleCancel = () => {
    setPaymentDetailsModal(false);
    setSpinner(false);
    setOpen1(0)
    // handleClose() // Pass handleClose

  };
  // console.log(selecteddata,"selecteddata");
  const onlinepaymentpayload ={
  "cargoType": "Air Cargo",
  "queryId": queryId,
    "bookingData": {
    "requestRefId": selecteddata?.requestRefId,
    "origin": selecteddata?.origin,
    "destination": selecteddata?.destination,
    "flightItineraries": selecteddata?.flightItineraries,
    "rateDetails": selecteddata?.rateDetails,
    "travelTime": selecteddata?.travelTime,
   
    "LAT": selecteddata?.LAT,
    "TOA": selecteddata?.TOA,
    "ailinelogoUrl": selecteddata?.ailinelogoUrl,
    "ratesFrom": selecteddata?.ratesFrom,
    // Offline rates carry the available space from /ratesearch/all; keep it on
    // the booking data so it reaches the booking payload unchanged.
    ...(selecteddata?.space_availability !== undefined &&
    selecteddata?.space_availability !== null
      ? { space_availability: selecteddata.space_availability }
      : {}),
  },
    //  "bookingAmount": "",//add in file
  "useCreditAmount": false,
  // "transactionId": 5114923396385,//add in file
  // "orderId": "order_1010115236eDxEcu0tfmMeauNvytW4yCicn",//add in file
}
const fspaymentpayload={
  ...onlinepaymentpayload,
bookingData: {
    ...onlinepaymentpayload.bookingData,
    productDescription: selecteddata?.productDescription||null,
    speedName: selecteddata?.speedName||null,
    hash: selecteddata?.hash||null,
    rateStatus: selecteddata?.rateStatus||null,
  }}
  useEffect (()=>{
    const payload=selecteddata?.ratesFrom==="FS"?fspaymentpayload:onlinepaymentpayload
dispatch (bookingdata(payload))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selecteddata])

  // useEffect(() => {
  //   if(queryidall.insertedRate||nodeData?.searchquery?.airlinepayloadData?.requestType==="2"){
       
  //   }
  //   // dispatch(getcreditlimit());
  // }, []);
  // old logic  december optimization
  // console.log(singlebookingdata)
  // useEffect(() => {
  //    const updatedNodeData = {
  //     ...nodeData,
  //     queryId: nodeData?.manualQuoteId ?nodeData?.queryId:queryidall?.insertedRate || queryidall?.qatarrate || queryidall?.frieghtos

  //   };

  //   const updatedProps = {
  //     ...props,
  //     queryId:nodeData?.manualQuoteId ?nodeData?.queryId: queryidall?.insertedRate || queryidall?.qatarrate || queryidall?.frieghtos
     
  //   };
  // //   const[newnodedat,setNewnodedata] = useState(nodeData);
  // // const [newprops,setNewprops] = useState(props);
  //   setNewnodedata(updatedNodeData);
  //   setNewprops(updatedProps);
  // },[queryidall,nodeData,props])
  // old logic  december optimization close 
  const handleCancelCashFree = () => {
    setPaymentDetailsModal(false);
    setSpinner(false);
    setBookingType("")
    setOpenModal(false);
    // setPaymentSessionId("");

    setPaymentSessionId("")
  };
// //kyc details for credit details
  // const bookFlight = (id) => {
  //   //item
  //   setSpinner(true);
  //   dispatch(kycdocstatus())
  //     .then((res) => {
  //       console.log("res", res);
  //       if (res.payload.data.verification_status === "Pending_Upload") {
  //         console.log("1");
  //         setSpinner(false);
  //         Modal.confirm({
  //           title:
  //             "Oops! Please complete your KYC verification for successfull booking!",
  //           icon: <ExclamationCircleFilled />,
  //           okText: "OK",
  //           onOk() {
  //             dispatch(updategotokyc(true));
  //             dispatch(savequeries(newnodedata));
  //             navigate("/user/kyc");
  //           },
  //           onCancel() {},
  //           cancelButtonProps,
  //           okButtonProps,
  //         });
  //       } else if (res.payload.data.verification_status === "Rejected") {
  //         console.log("2");
  //         setSpinner(false);
  //         Modal.confirm({
  //           title:
  //             "Oops! Your KYC verification is rejected. Please complete your KYC verification for successfull booking!",
  //           icon: <ExclamationCircleFilled />,
  //           okText: "OK",
  //           onOk() {
  //             dispatch(updategotokyc(true));
  //             dispatch(savequeries(newnodedata));
  //             navigate("/user/kyc");
  //           },

  //           onCancel() {},
  //           cancelButtonProps,
  //           okButtonProps,
  //         });
  //       } else if (res.payload.data.verification_status === "Processing") {
  //         console.log("4")
  //         setSpinner(false);

  //         Modal.confirm({
  //           title:
  //             "Your KYC Verification is under process. You will be notified once admin approves the same.",
  //           icon: <ExclamationCircleFilled />,
  //           okText: "OK",
  //           cancelButtonProps,
  //           okButtonProps,
  //         });
  //       } else if (res.payload.data.verification_status === "Accepted") {
  //         console.log("3")
  //         console.log("id", id);
  //         setQueryId(id);
  //         // setSelectedItem(item)
  //         dispatch(getcreditlimit())
  //           .then((res) => {
  //             if (res?.payload?.data?.statusCode === 200) {
  //               setSpinner(false);
  //               setCreditLimitData(res?.payload?.data?.data);
  //               // setRemainingBalance(item?.totalFreightRate);
  //               if (
  //                 res?.payload?.data?.data?.available_amount > 0 &&
  //                 res?.payload?.data?.data?.active === "active"
  //               ) {
  //                 setPaymentDetailsModal(true);
  //               } else {
  //                 setOpenModal(true);
  //                 setUseCreditAmount(false);
  //               }
  //             }
  //           })
  //           .catch((err) => {
  //             console.error(err);
  //           });

  //         // Order creation start here
  //         // ==========================
  //         // setQueryDatas({'cargoType':nodeData.cargoType,'queryId':id,'bookingData':{...item}})
  //         // dispatch(getorderid({'cargoType':nodeData.cargoType,'queryId':id,'bookingData':{...item}}))
  //         // .then(res=>{
  //         //     const resData = res?.payload?.data
  //         //     if(resData.statusCode === 200){
  //         //         setSpinner(false);
  //         //         setPaymentSessionId(resData?.data?.payment_session_id)
  //         //         //setIsModalOpen(true)
  //         //     }
  //         // })
  //         // .catch(err => {
  //         //     console.error(err);
  //         // })
  //       }
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // };
  // //kyc details for credit details close
  // console.log(nodeData,'nodeData')
  //kyc details for credit details
  // useEffect(() => {
  //   // if (newnodedata?.status == "New") {//Quoted
  //     bookFlight(newnodedata?.queryId);
  //   // }
  // }, []);
  //kyc details for credit details close
  // useEffect(() => {
  //   if (Object.keys(responseMsg).length > 0) {
  //     dispatch(updatenotificationdata(responseMsg));
  //     if (responseMsg.success !== "error") {
  //       nodeData.cargoType === "Air Cargo"
  //         ? dispatch(updatebookinghistorytabvalue(1))
  //         : dispatch(updatebookinghistorytabvalue(2));
  //       navigate("/booking-history");
  //     }
  //   }
  // }, [responseMsg]);
  // console.log(paymentSessionId,"paymentSessionId")
  // console.log(bookingType,openModal,"bookingType")

  return (
    <>
      {/* <h2>Payment</h2> */}
      {/* {contextHolder}
            {
                nodeData.cargoType === 'Ocean Cargo' ?
                    <button disabled={spinner || nodeData?.paymentStatus === 'Pending' || nodeData?.status === 'New' || nodeData?.status === 'Booked' || nodeData?.status === 'Expired' || !Number(item.USD_totalFreightRate) ? true : false} onClick={()=>bookFlight(nodeData?.queryId,item)} type="submit" className="text-white bg-primary hover:bg-secondary font-bold leading-4 rounded-lg text-sm px-4 py-2.5 text-center  flex items-center justify-center gap-2 shadow-searchbox w-full flex-wrap">
                        {
                            spinner ?
                                <Spin/>
                            :
                                ((nodeData?.status === 'Quoted' && nodeData?.paymentStatus === 'New') || (nodeData?.status === 'New' && nodeData?.paymentStatus === 'New')) ?
                                    <span>
                                        { Number(item.USD_totalFreightRate) ? `Book For : $ ${item?.USD_totalFreightRate} ( ₹ ${item?.totalFreightRate}) **` : item?.USD_totalFreightRate}
                                    </span>
                                :
                                nodeData?.status === 'Expired' ?
                                    <span>Expired</span>
                                :
                                (nodeData?.status === 'Booked' || nodeData?.paymentStatus === 'Pending') &&
                                <span>Booked</span>
                        }
                    </button>
                :
                    <button disabled={spinner || nodeData?.status === 'New' || nodeData?.status === 'Booked' || nodeData?.status === 'Expired' || !Number(item.totalFreightRate) ? true : false} onClick={()=>bookFlight(nodeData?.queryId,item)} type="submit" className="text-white bg-primary hover:bg-secondary font-bold leading-4 rounded-lg text-sm px-4 py-2.5 text-center  flex items-center justify-center gap-2 shadow-searchbox w-full flex-wrap">
                        {
                            spinner ?
                                <Spin/>
                            :
                                ((nodeData?.status === 'Quoted' && nodeData?.paymentStatus === 'New') || (nodeData?.status === 'New' && nodeData?.paymentStatus === 'New')) ?
                                    // <><span>Book For </span><span>{ Number(item.totalFreightRate) ? `₹` :''} {item.totalFreightRate}**</span></>
                                    <span>
                                        { Number(item.totalFreightRate) ? `Book For : ₹ ${item?.totalFreightRate} **` : item?.totalFreightRate}
                                    </span>
                                :
                                nodeData?.status === 'Expired' ?
                                    <span>Expired</span>
                                :
                                nodeData?.status === 'Booked' &&
                                <span>Booked</span>
                        }
                    </button>
            } */}
      {/* {
                openModal && */}
      {/* <Suspense fallback={<Skeleton avatar/>}> */}
      <CargoPayment
        // nodeData={nodeData}
        // queryId={queryId}
        // selectedItem={selectedItem}
        setOpenModal={setOpenModal}
        setSpinner={setSpinner}
        openModal={openModal}
        // paymentId={paymentId}
        remainingBalance={remainingBalance}
        // creditPayedAmount={creditPayedAmount}
        setQueryDatas={setQueryDatas}
        setPaymentSessionId={setPaymentSessionId}
        setBookingType={setBookingType}
        setPaymentDetailsModal={setPaymentDetailsModal}
      />
      {/* </Suspense> */}
      {/* } */}
      {/* { */}
      {/* paymentDetailsModal && */}
      {/* <Modal open={paymentDetailsModal} wrapClassName='payment-modal' onCancel={handleCancel} closable = {false} centered =  {true} footer={null} width={800} >
                    <Suspense fallback={<Skeleton avatar/>}> */}
      <PaymentDetailsModal
        creditLimitData={creditLimitData}
        // props={newprops}
        selecteddata={selecteddata}
        rqueryid={rqueryid}
       setOrderId={setOrderId}
       orderId={orderId}
       prevbookingamt={prevbookingamt}
        setPaymentDetailsModal={setPaymentDetailsModal}
        setUseCreditAmount={setUseCreditAmount}
        useCreditAmount={useCreditAmount}
        selectedItem={selecteddata}
        setOpenbooking={setOpenbooking}
        setSelecteddata={setSelecteddata}
        // setOpens={setOpens}
        // nodeData={newnodedata}
        handleCancel={handleCancel}
        // queryId={queryId}
        setQueryDatas={setQueryDatas}
        setQueryId={setQueryId}
        setPaymentSessionId={setPaymentSessionId}
        paymentSessionId={paymentSessionId}
        setBookingType={setBookingType}
        setRemainingBalance={setRemainingBalance}
        setOpenModal={setOpenModal}
      />
      {/* </Suspense>

                </Modal> */}
      {/* } */}
      {/* {
                paymentSessionId && */}
      {/* <Modal open={paymentSessionId ? true : false} onCancel={()=>handleCancelCashFree(queryDatas)} okButtonProps={{ hidden: true }} maskClosable={false} cancelButtonProps={{ hidden: true }} closable = {true}>
                    <Suspense fallback={<Skeleton active/>}> */}
                  {/* {console.log(paymentSessionId,"paymentSessionId")} */}
      <AlertDialogBox
        //  open={open}
        type="cancelBooking"
        open={bookingType ==="online" ? true: false}      
        wrapClassName="payment-modal"
        okButtonProps={{ hidden: true }} maskClosable={false} cancelButtonProps={{ hidden: true }} closable = {true}
        // handleBack={() => navigate(-1)}
        handleClose={() => handleCancelCashFree()}
      >
          <div className="w-full p-5">
          <CashFreePaymentModal
          paymentSessionId={paymentSessionId}
          bookingType={bookingType}
          // props={newprops}
          // nodeData={newnodedata}
          setPaymentSessionId={setPaymentSessionId}
          setResponseMsg={setResponseMsg}
          // queryId={queryId}
          queryDatas={queryDatas}
          orderId={orderId}
          selectedItem={selecteddata}
        />
          </div>
       
      </AlertDialogBox>

      {/* </Suspense>
                </Modal> */}
      {/* } */}

      {/* { bookingType === 'manual' && //?setOpen(false):setOpen(true)
                <Modal open={bookingType === 'manual' ? true : false}   onCancel={handleCancel} closable = {false} centered = {true} footer={null} maskStyle={{padding:0}} width={ bookingType === 'manual' ? 600 :800} wrapClassName='payment-modal' className='z-12'> */}
      <AlertDialogBox
        //  open={open}
        type="cancelBooking"
        open={bookingType === "manual" ? true : false}
        // onCancel={handleCancel}
        // closable={false}
        // centered={true}
        // footer={null}
        // maskStyle={{ padding: 0 }}
        width={bookingType === "manual" ? 600 : 800}
        wrapClassName="payment-modal"
        handleBack={() => navigate(-1)}
        handleClose={() => setBookingType("")&&setOpen1(0) }
      >
        <div className="w-full p-5">
          <ManualPayment
            setBookingType={setBookingType}
            // nodeData={newnodedata}
            // props={newprops}
            // queryId={queryId}
            selectedItem={selecteddata}
            remainingBalance={remainingBalance}
            useCreditAmount={useCreditAmount}
            handleClose={handleClose}
            setOpen1={setOpen1}
            open1={open}
          />
        </div>
      </AlertDialogBox>

      {/* </Modal>} */}
      {/* } */}
    </>
  );
};

export default React.memo(BookCargo);
